module.exports = __webpack_public_path__ + "assets/img/discuss-bg2.76523000.png";